import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Chip,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import "./batches.scss";
import Label from "../../../components/Label/Label";
import KeyboardArrowDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowUpIcon from "@mui/icons-material/ArrowDropUp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  openData,
  moreOption,
  handleMenuOption,
  batchID,
  batchDetails
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openRow, setOpenRow] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleExpand = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const toggleSection = (rowId, section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [section]: !prev[rowId]?.[section],
      },
    }));
  };

  const headers = Array.from(
    new Set(data?.rows.flatMap((obj) => Object.keys(obj)))
  );
  //  const headers = []
  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        overflow="auto"
        className="audit-table-container"
        sx={{
          maxHeight: "calc(100vh - 250px)",
          boxShadow: "none",
          overflow: "auto",
        }}
      >
        <Table stickyHeader>
          <TableHead className="table-header">
            <TableRow>
              {headers.map((key) => (
                <TableCell
                  className="table-header-cell"
                  key={key}
                  sx={{ fontWeight: "bold" }}
                >
                  {key}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.rows?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map((key) => (
                  <TableCell sx={{ fontSize:14}} key={key}>
                    {row[key] !== undefined ? row[key] : "-"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            {(!batchDetails?.loader && data?.rows?.length === 0) || (data === undefined || data?.rows?.length === 0 )  ? (
              <TableRow>
                <TableCell colSpan={headers?.length || 7} align="center">
                  <Label color="textSecondary" text={"No data found"} />
                </TableCell>
              </TableRow>
            ): null}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
